/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_Sources_CountInputs */



/**
* | output |
* | --- |
* | "{count} sources" |
*
* @param {Meeting_Sources_CountInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_count = /** @type {((inputs: Meeting_Sources_CountInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_CountInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.count} bronnen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} sources`)
	return /** @type {LocalizedString} */ (`${i?.count} sources`)
});